<!-- eslint-disable vue/no-mutating-props -->
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <v-dialog
        max-width="900"
        v-model="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        content-class="sc-modal sc-modal--lg"
        scrollable
      >
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--edit" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Editar">
            <v-icon>mdi-pencil</v-icon>
          </div>
        </template>
        <span>Editar</span>
      </v-tooltip>
        </template>

        <v-card v-if="dialog" flat class="sc-modal__card" :key="item.id">
          <!-- Close button -->
          <v-btn
            icon
            class="sc-modal__close"
            @click="close(true)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <!-- Hero Header -->
          <div class="hero-header">
            <div class="hero-image-container">
              <template v-if="urlImagemEnquete">
                <v-img
                  class="hero-image"
                  :src="urlImagemEnquete"
                  @error="onEnqueteImageError"
                >
                  <div class="image-overlay">
                    <v-btn
                      icon
                      small
                      class="image-action-btn"
                      @click="removeEnqueteImage"
                      :loading="isRemovingEnqueteImage"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      class="image-action-btn"
                      @click="triggerImageUpload"
                      :loading="isUploadingEnqueteImage"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </template>
              <template v-else>
                <div class="hero-image-placeholder" @click="triggerImageUpload">
                  <v-icon size="40" color="text_secondary">mdi-image-plus</v-icon>
                  <span class="placeholder-text">Adicionar imagem</span>
                </div>
              </template>
              <input
                ref="enqueteImageInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="onEnqueteImageInputChange"
              />
            </div>

            <div class="hero-content">
              <div class="hero-title-row">
                <ModalEditarTituloEnquete
                  :enquete="item"
                  @title-updated="onTitleUpdated"
                />
              </div>
              <span class="hero-meta">
                <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                Atualizado em {{ item.updated_at | formatedDate }} às {{ item.updated_at | formatedHour }}h
              </span>

              <!-- Toggle Switches -->
              <div class="toggle-group">
                <div class="toggle-item">
                  <v-switch
                    v-model="showResults"
                    @change="updateExibirResultado"
                    color="primary"
                    hide-details
                    dense
                  ></v-switch>
                  <div class="toggle-label">
                    <span class="toggle-title">Mostrar resultados</span>
                    <span class="toggle-description">Exibir porcentagem na tarja</span>
                  </div>
                </div>

                <div v-if="hasValidQRCode" class="toggle-item">
                  <v-switch
                    v-model="showQRCodeAlongside"
                    @change="updateQRCodeSetting"
                    color="primary"
                    hide-details
                    dense
                    :key="`qr-switch-${item.id}`"
                  ></v-switch>
                  <div class="toggle-label">
                    <span class="toggle-title">QR Code combinado</span>
                    <span class="toggle-description">Exibir enquete e QR Code juntos</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Options Section -->
          <div class="options-section">
            <div class="options-header">
              <v-icon small class="mr-2">mdi-format-list-bulleted</v-icon>
              <span>Opções da enquete</span>
            </div>

            <v-card-text class="options-scroll-area pa-0">
              <div class="options-grid">
                <div
                  v-for="(opcao, idx) in item.enquete_opcoes"
                  :key="opcao.id"
                  class="option-card"
                >
                  <CardOpcaoEnquete
                    :enquete="item"
                    :opcao="opcao"
                    :index="idx"
                    :aprovadas_current_page="pageRecebidas"
                    @option-updated="onOptionUpdated"
                  />
                </div>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CardOpcaoEnquete from "@/components/Cards/Enquetes/CardOpcaoEnquete.vue";
import ModalEditarTituloEnquete from "@/components/Modal/Enquetes/ModalEditarTituloEnquete.vue";
import { apiClient } from "@/services/api";

export default {
  components: { CardOpcaoEnquete, ModalEditarTituloEnquete },
  data() {
    return {
      dialog: false,
      showResults: null,
      showQRCodeAlongside: false,
      urlImagemEnquete: null,
      dscArquivoEnqueteGcp: null,
      isUploadingEnqueteImage: false,
      isRemovingEnqueteImage: false,
    };
  },
  created() {
    this.seedFromItem();
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  props: {
    item: Object,
    pageRecebidas: Number,
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
  },
  methods: {
    ...mapActions({
      getEnquetesProducao: "enquetes/getEnquetesProducao",
      getEnqueteEmExibicao: "enquetes/getEnqueteEmExibicao",
    }),
    close(isCancelarEvent = false) {
      if (isCancelarEvent) {
        this.dialog = false;
      }
      this.$emit("close");
    },
    onOptionUpdated() {
      this.$emit('option-updated');
    },
    onTitleUpdated() {
      this.$emit('option-updated');
    },
    async updateExibirResultado() {
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;

      try {
        await apiClient.patch(`/producao/${cod_producao}/flag-exibir-resultado`, {
          exibir_resultado: this.showResults,
        });

        this.$store.commit('producoes/updateSelectedProducao', {
          settings: {
            ...this.$store.state.producoes.selectedProducao.settings,
            enquete: {
              ...this.$store.state.producoes.selectedProducao.settings?.enquete,
              exibir_resultado: this.showResults,
            },
          },
        });

        await this.getEnquetesProducao({
          cod_producao: cod_producao,
          filtro_texto: this.$store.state.enquetes.filtroEnquetes,
          size: 5,
          page: this.$store.state.enquetes.enquetesProducao.currentPage,
          cod_portal: this.$store.state.enquetes.selectedPortal,
          id_categoria: this.$store.state.enquetes.selectedCategoria,
        });
        await this.getEnqueteEmExibicao({
          cod_producao: cod_producao,
        });
      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao atualizar exibição de resultados");
      }
    },
    seedFromItem() {
      this.showResults = this.item?.flg_exibir_resultado ?? null;
      this.loadQRCodeCombinedSetting();
      this.loadEnqueteImage();
    },
    loadQRCodeCombinedSetting() {
      const selectedProducao = this.$store.state.producoes.selectedProducao;
      this.showQRCodeAlongside = selectedProducao?.settings?.enquete?.qr_code_combined ?? false;
    },
    async updateQRCodeSetting() {
      if (this.showQRCodeAlongside && !this.hasValidQRCode) {
        this.$toast.warning("Esta enquete não possui QR Code válido");
        this.showQRCodeAlongside = false;
        return;
      }

      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;

      try {
        await apiClient.patch(`/producao/${cod_producao}/flag-qr-code-combined`, {
          qr_code_combined: this.showQRCodeAlongside,
        });

        this.$store.commit('producoes/updateSelectedProducao', {
          settings: {
            ...this.$store.state.producoes.selectedProducao.settings,
            enquete: {
              ...this.$store.state.producoes.selectedProducao.settings?.enquete,
              qr_code_combined: this.showQRCodeAlongside,
            },
          },
        });

        await this.getEnquetesProducao({
          cod_producao: cod_producao,
          filtro_texto: this.$store.state.enquetes.filtroEnquetes,
          size: 5,
          page: this.$store.state.enquetes.enquetesProducao.currentPage,
          cod_portal: this.$store.state.enquetes.selectedPortal,
          id_categoria: this.$store.state.enquetes.selectedCategoria,
        });
        await this.getEnqueteEmExibicao({
          cod_producao: cod_producao,
        });
      } catch (error) {
        console.error('Error updating QR code setting:', error);
        this.$toast.error("Erro ao atualizar configuração do QR Code");
        this.showQRCodeAlongside = !this.showQRCodeAlongside;
      }
    },
    loadEnqueteImage() {
      this.urlImagemEnquete = this.item?.url_thumbnail_enquete || null;
      this.dscArquivoEnqueteGcp = this.item?.dsc_nome_arquivo_enquete || null;
    },
    triggerImageUpload() {
      this.$refs.enqueteImageInput?.click();
    },
    onEnqueteImageInputChange(event) {
      const file = event.target.files?.[0];
      if (file) {
        this.onEnqueteImageChange(file);
      }
      event.target.value = '';
    },
    transformFileNameToUniqueName(fileName) {
      const data_hoje = new Date();
      const miliseconds = data_hoje.getMilliseconds();
      const data_formatada = data_hoje
        .toLocaleString("pt-BR", {
          month: "numeric",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
        })
        .replaceAll(",", "")
        .replaceAll("/", "")
        .replaceAll(":", "")
        .replaceAll(" ", "")
        .concat("-", String(miliseconds))
        .concat("-", fileName);

      return data_formatada;
    },
    async onEnqueteImageChange(file) {
      if (this.isUploadingEnqueteImage || !file) return;

      const file_type = file.type.split("/");
      if (!file_type[1]) {
        this.$toast.error("Tipo de arquivo inválido");
        return;
      }

      const selectedProducao = this.$store.state.producoes.selectedProducao;
      if (!selectedProducao?.cod_producao) {
        this.$toast.error("Nenhuma produção selecionada");
        return;
      }

      if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
        URL.revokeObjectURL(this.urlImagemEnquete);
      }
      this.urlImagemEnquete = URL.createObjectURL(file);

      const fileName = `enquete_${this.item.id}.${file_type[1]}`;
      this.dscArquivoEnqueteGcp = this.transformFileNameToUniqueName(fileName);

      this.isUploadingEnqueteImage = true;
      try {
        await apiClient.post(
          "uploadFileToGCP",
          {
            file: file,
            subpasta: "enquetes",
            fileName: this.dscArquivoEnqueteGcp,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const response = await apiClient.get(
          `getBucketImages/?fileName=${encodeURIComponent(this.dscArquivoEnqueteGcp)}&subpasta=enquetes`
        );

        if (!response.data) {
          throw new Error("Failed to get uploaded image URL");
        }

        await apiClient.patch(
          `/producao/${selectedProducao.cod_producao}/enquetes/${this.item.id}`,
          {
            url_imagem: response.data.url,
            url_thumbnail: response.data.url,
            dsc_nome_arquivo: this.dscArquivoEnqueteGcp,
          }
        );

        await this.refreshEnquetes();
        this.$toast.success("Imagem da enquete adicionada com sucesso");
      } catch (error) {
        console.error("Error uploading enquete image:", error);
        this.$toast.error("Erro ao adicionar imagem da enquete");
        if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
          URL.revokeObjectURL(this.urlImagemEnquete);
        }
        this.urlImagemEnquete = null;
        this.dscArquivoEnqueteGcp = null;
      } finally {
        this.isUploadingEnqueteImage = false;
      }
    },
    onEnqueteImageError() {
      if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
        URL.revokeObjectURL(this.urlImagemEnquete);
      }
      this.urlImagemEnquete = null;
      this.dscArquivoEnqueteGcp = null;
    },
    async removeEnqueteImage() {
      if (this.isRemovingEnqueteImage) return;

      const selectedProducao = this.$store.state.producoes.selectedProducao;
      if (!selectedProducao?.cod_producao) {
        this.$toast.error("Nenhuma produção selecionada");
        return;
      }

      this.isRemovingEnqueteImage = true;
      try {
        if (this.dscArquivoEnqueteGcp) {
          await apiClient.delete(
            `deleteBucketImage/?fileName=${encodeURIComponent(this.dscArquivoEnqueteGcp)}&subpasta=enquetes`
          );
        }

        if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
          URL.revokeObjectURL(this.urlImagemEnquete);
        }
        this.urlImagemEnquete = null;
        this.dscArquivoEnqueteGcp = null;

        await apiClient.patch(
          `/producao/${selectedProducao.cod_producao}/enquetes/${this.item.id}`,
          {
            url_imagem: null,
            url_thumbnail: null,
            dsc_nome_arquivo: null,
          }
        );

        await this.refreshEnquetes();
        this.$toast.success("Imagem da enquete removida com sucesso");
      } catch (error) {
        console.error("Error removing enquete image:", error);
        this.$toast.error("Erro ao remover imagem da enquete");
      } finally {
        this.isRemovingEnqueteImage = false;
      }
    },
    async refreshEnquetes() {
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
      await this.getEnquetesProducao({
        cod_producao: cod_producao,
        filtro_texto: this.$store.state.enquetes.filtroEnquetes,
        size: 5,
        page: this.$store.state.enquetes.enquetesProducao.currentPage,
        cod_portal: this.$store.state.enquetes.selectedPortal,
        id_categoria: this.$store.state.enquetes.selectedCategoria,
      });
      await this.getEnqueteEmExibicao({
        cod_producao: cod_producao,
      });
    },
  },
  watch: {
    dialog(open) {
      if (open) this.seedFromItem();
    },
    '$store.state.producoes.selectedProducao.settings.enquete.qr_code_combined': function(newValue) {
      if (newValue !== undefined && newValue !== this.showQRCodeAlongside) {
        this.showQRCodeAlongside = newValue;
      }
    },
    '$store.state.producoes.selectedProducao': function(newProducao) {
      if (newProducao) {
        this.loadQRCodeCombinedSetting();
      }
    },
    'item.flg_exibir_resultado': function(newValue) {
      if (newValue !== undefined && newValue !== this.showResults) {
        this.showResults = newValue;
      }
    },
    'item.url_thumbnail_enquete': function(newValue) {
      if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
        URL.revokeObjectURL(this.urlImagemEnquete);
      }
      this.urlImagemEnquete = newValue || null;
    },
    'item.dsc_nome_arquivo_enquete': function(newValue) {
      this.dscArquivoEnqueteGcp = newValue || null;
    },
  },
  beforeDestroy() {
    if (this.urlImagemEnquete && this.urlImagemEnquete.startsWith("blob:")) {
      URL.revokeObjectURL(this.urlImagemEnquete);
    }
  },
};
</script>

<style lang="scss" scoped>
.editButton {
  background: var(--v-surface_neutral_selected-base) !important;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  &:hover {
    transform: scale(1.1);
    background: var(--v-primary-base) !important;
  }
}

/* Hero Header */
.hero-header {
  display: flex;
  gap: 24px;
  padding: 24px;
  background: linear-gradient(135deg, var(--v-surface_tertiary-base) 0%, var(--v-surface_secondary-base) 100%);
  border-bottom: 1px solid var(--sc-border-subtle);
}

.hero-image-container {
  flex-shrink: 0;
  width: 200px;
  height: 140px;
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;

  .image-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 50%);
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 8px;
    gap: 4px;
    opacity: 0;
    transition: opacity var(--sc-duration-base) var(--sc-easing-standard);
  }

  &:hover .image-overlay {
    opacity: 1;
  }
}

.image-action-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);

  &:hover {
    background: rgba(255, 255, 255, 0.25) !important;
  }
}

.hero-image-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--v-surface_neutral-base) 0%, var(--v-surface_tertiary-base) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  border: 2px dashed var(--sc-border-default);

  &:hover {
    border-color: var(--v-primary-base);
    background: linear-gradient(135deg, var(--v-surface_tertiary-base) 0%, var(--v-surface_neutral-base) 100%);

    .v-icon {
      color: var(--v-primary-base) !important;
    }
  }

  .placeholder-text {
    font-size: 0.75rem;
    color: var(--v-text_secondary-base);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.hero-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-right: 40px;
}

.hero-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  min-height: 44px;
}

.hero-meta {
  font-size: 0.75rem;
  color: var(--v-text_secondary-base);
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

/* Toggle Switches */
.toggle-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--sc-surface-tint);
  border-radius: var(--sc-radius-md);
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  &:hover {
    background: var(--sc-surface-tint-hover);
  }
}

.toggle-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toggle-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v-text_primary-base);
}

.toggle-description {
  font-size: 0.7rem;
  color: var(--v-text_secondary-base);
}

/* Options Section */
.options-section {
  padding: 20px 24px 24px;
}

.options-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.options-scroll-area {
  max-height: 450px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
}

.options-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-card {
  background: var(--v-surface_tertiary-base);
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;

  &:hover {
    background: var(--sc-surface-tint-stronger);
  }
}


/* Animations */
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

/* Deep styles for nested components */
::v-deep .v-input--switch {
  margin: 0;
  padding: 0;
}

::v-deep .v-input--switch__track {
  opacity: 0.3;
}


</style>
